import { render, staticRenderFns } from "./RegisterForm2.vue?vue&type=template&id=bd0c949a&scoped=true&"
import script from "./RegisterForm2.vue?vue&type=script&lang=js&"
export * from "./RegisterForm2.vue?vue&type=script&lang=js&"
import style0 from "./RegisterForm2.vue?vue&type=style&index=0&id=bd0c949a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd0c949a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/c6monbi/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bd0c949a')) {
      api.createRecord('bd0c949a', component.options)
    } else {
      api.reload('bd0c949a', component.options)
    }
    module.hot.accept("./RegisterForm2.vue?vue&type=template&id=bd0c949a&scoped=true&", function () {
      api.rerender('bd0c949a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "js/RegisterForm2.vue"
export default component.exports